import { useSelector } from 'react-redux';
import { getBiverkningSubTableSelector } from './selectors.ts';

export const useGetBiverkningSubTable = () => {
    return useSelector(getBiverkningSubTableSelector);
};
